import React from 'react';

import { WebCampaignType } from '@/global';
import { webCampaign } from '@/modules/webCampaign';

import RoleplayVariant from './Variants/Roleplay/Roleplay';

const PostPaywallNameVariantMap: Record<
  NonNullable<WebCampaignType['postPaywallName']>,
  React.FC
> = {
  roleplay: RoleplayVariant,
};

const PostPaywallName: React.FC = () => {
  const PostPaywallNameVariant =
    PostPaywallNameVariantMap[webCampaign.setup.postPaywallName || 'roleplay'];

  return <PostPaywallNameVariant />;
};

export default PostPaywallName;
